import React from "react";
import _ from "lodash";

import logo from "assets/images/say-what/saywhat-logo.png";

const Start = ({ users, mobile_app, start_params }) => {
  const top_label = _.get(
    start_params,
    "top_label",
    "Waiting for players to join"
  );

  return (
    <div className="say-what-lobby">
      <div className="content">
        <img src={logo} alt="logo" />
        <p className="waiting-txt">{top_label}</p>
      </div>
      <div
        className={`lobby-players ${
          mobile_app ? "player-cnt-mobile" : "player-cnt"
        }`}
      >
        {users.map((item) => {
          return (
            <div key={item.player_id} className="player-card">
              <p className="name">{item.display_name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Start;
